enum UserRoleEnum {
  ADMIN = 'admin',
  USER = 'staff user',
}

export { UserRoleEnum };
